import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  return (
    <section id="faq" aria-labelledby="faq-title" className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-primary-500" />
            常见问题
          </p>
          <h2 id="faq-title" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            你可能想问的几件事
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            关于核实标准、更正流程和栏目差异，我们把最常被追问的问题整理在这里。如果还有疑问，欢迎直接写信给我们。
          </p>
          <a
            href="mailto:contact@baoliao-online.example.com"
            className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-mail-line" aria-hidden="true" />
            写邮件提问
          </a>
        </div>
        <div className="lg:col-span-8">
          <FaqAccordion items={faqs} />
        </div>
      </div>
    </section>
  );
}